import GuardedRoute from './lib/GuardedRoute';
import GuardedProvider from './lib/GuardedProvider';

export default {
  GuardedRoute,
  GuardedProvider,
};
